// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileAddOutlinedSvg from "@ant-design/icons-svg/es/asn/FileAddOutlined";
import AntdIcon from '../components/AntdIcon';

var FileAddOutlined = function FileAddOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileAddOutlinedSvg
  }));
};

FileAddOutlined.displayName = 'FileAddOutlined';
export default React.forwardRef(FileAddOutlined);